// Values of the `tab` query parameter the organization form opens on.
export const organizationTab = {
  details: "details",
  integrations: "integrations",
  quoteOptions: "quote-options",
} as const;

export type OrganizationTab =
  (typeof organizationTab)[keyof typeof organizationTab];
